import AddCard from "@/views/AddCard/AddCard.vue";
import DocumentsPage from "@/views/Documents/DocumentsPage.vue";
import EditCard from "@/views/EditCard/EditCard.vue";
import LoginPage from "@/views/Enter/LoginPage.vue";
import LoginYandex from "@/views/Enter/LoginYandex.vue";
import HomeView from "@/views/HomeView.vue";
import NotificationsPage from "@/views/Notifications/NotificationsPage.vue";
import ProfilePage from "@/views/Profile/ProfilePage.vue";
import NewReferralPage from "@/views/Refferal/NewRefferalPage.vue";
import SupportPage from "@/views/Settings/Pages/SupportPage.vue";
import SettingsPage from "@/views/Settings/SettingsPage.vue";
import StoreApp from "@/views/Store/AndroidStore.vue";
import AppleStore from "@/views/Store/AppleStore.vue";
import SuccessInstall from "@/views/Store/SuccessInstall.vue";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/home",
    name: "Home",
    component: HomeView,
    meta: {
      layout: true,
      title: "Главная",
    },
  },
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
    meta: {
      layout: false,
      title: "Логин",
    },
  },
  {
    path: "/login-yandex",
    name: "LoginYandex",
    component: LoginYandex,
    meta: {
      layout: false,
      title: "Логин Yandex",
    },
  },
  {
    path: "/profile",
    name: "ProfilePage",
    component: ProfilePage,
    meta: {
      layout: true,
      title: "Профиль",
    },
  },
  {
    path: "/settings",
    name: "SettingsPage",
    component: SettingsPage,
    meta: {
      layout: true,
      title: "Настройки",
    },
  },
  {
    path: "/documents",
    name: "DocumentsPage",
    component: DocumentsPage,
    meta: {
      layout: true,
      title: "Документы",
    },
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
    meta: {
      layout: true,
      title: "Центр нотификаций",
    },
  },
  {
    path: "/edit-card/:cardId",
    name: "EditCard",
    component: EditCard,
    meta: {
      layout: true,
      title: "Редактирование карты",
    },
  },
  {
    path: "/new-card",
    name: "NewCard",
    component: AddCard,
    meta: {
      layout: true,
      title: "Добавление карты",
    },
  },
  {
    path: "/support-page",
    name: "SupportPage",
    component: SupportPage,
    meta: {
      layout: true,
      title: "Поддержка",
    },
  },
  {
    path: "/android",
    name: "AndroidStore",
    component: StoreApp,
    meta: {
      layout: false,
      title: "Force Play | Android",
    },
  },
  {
    path: "/referral-page",
    name: "NewReferralPage",
    component: NewReferralPage,
    meta: {
      layout: true,
      title: "Реферальная программа",
    },
  },
  {
    path: "/success-install",
    name: "SuccessInstall",
    component: SuccessInstall,
    meta: {
      layout: false,
      title: "Force Play | Success Install",
    },
  },
  {
    path: "/ios",
    name: "AppleStore",
    component: AppleStore,
    meta: {
      layout: false,
      title: "Force Market | IOS",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/login-yandex&")) {
    const hash = window.location.hash;
    const correctedHash = hash.replace("/login-yandex&", "/login-yandex?");
    const correctedUrl = window.location.href.replace(hash, correctedHash);

    window.history.replaceState({}, "", correctedUrl);
    next({ path: "/login-yandex", query: to.query });
    return;
  }

  if (
    to.path === "/login-yandex" &&
    window.location.hash.includes("&access_token=")
  ) {
    const hash = window.location.hash;
    const correctedHash = hash.replace("&access_token=", "?access_token=");
    const correctedUrl = window.location.href.replace(hash, correctedHash);

    window.history.replaceState({}, "", correctedUrl);
    next({ path: "/login-yandex", query: to.query });
    return;
  }

  next();
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
});

export default router;
